import { z } from "zod/v4-mini";

import { Profession, professionSchema } from "@/models/ProfessionModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type CareTeamParticipant = {
  id: string;
  givenName: string;
  familyName: string;
  qualification: Profession;
  userId: string;
  profilePicture?: {
    url: string;
  };
};

export const careTeamParticipantSchema: Schema<CareTeamParticipant> = cz.camelCaseObject({
  id: z.string(),
  givenName: z.string(),
  familyName: z.string(),
  qualification: professionSchema,
  user_id: z.string(),
  profile_picture: cz.optional(
    z.object({
      url: z.string(),
    }),
  ),
});
